import { render, staticRenderFns } from "./examen-cliniques.html?vue&type=template&id=e8824e5a&scoped=true&external"
import script from "./examen-cliniques.js?vue&type=script&lang=js&external"
export * from "./examen-cliniques.js?vue&type=script&lang=js&external"
import style0 from "./examen-cliniques.scss?vue&type=style&index=0&id=e8824e5a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8824e5a",
  null
  
)

export default component.exports